<script>
import StepForm from './StepForm.vue';

const STEPS = [
  {
    id: 1,
    title: 'Мой автомобиль',
    fields: [
      {
        id: 1,
        kind: 'input',
        name: 'brand',
        type: 'text',
        placeholder: 'Марка',
        required: true,
      },
      {
        id: 2,
        kind: 'input',
        name: 'model',
        type: 'text',
        placeholder: 'Модель',
        required: true,
      },
      {
        id: 3,
        kind: 'input',
        name: 'year',
        type: 'text',
        placeholder: 'Год выпуска',
        required: true,
      },
    ],
  },
  {
    id: 2,
    title: 'Дополнительные данные',
    fields: [
      {
        id: 1,
        kind: 'input',
        name: 'mileage',
        type: 'text',
        placeholder: 'Пробег',
        required: true,
      },
      {
        id: 2,
        kind: 'input',
        name: 'wheel',
        type: 'text',
        placeholder: 'Руль',
      },
      {
        id: 3,
        kind: 'input',
        name: 'owners',
        type: 'text',
        placeholder: 'Кол-во владельцев',
      },
      {
        id: 4,
        kind: 'input',
        name: 'price',
        type: 'text',
        format: 'price',
        placeholder: 'Ваша цена продажи',
      },
      {
        id: 3,
        kind: 'select',
        name: 'state',
        placeholder: 'Состояние автомобиля',
        options: [
          {id: 1, name: 'Идеальное'}, {id: 2, name: 'Хорошее'}, {id:3, name: 'Удовлетворительное'}
        ],
        required: true,
      },
    ],
  },
  {
    id: 3,
    title: 'Персональные данные',
    fields:[
      {
        id: 1,
        kind: 'input',
        name: 'name',
        type: 'text',
        placeholder: 'Имя',
        required: true,
      },
      {
        id: 2,
        kind: 'input',
        name: 'phone',
        format: 'phone',
        placeholder: '+7 (___) ___-__-__',
        validationRule: /\+7 \([0-9]{3}\) [0-9]{3}-[0-9]{2}-[0-9]{2}/,
        required: true,
      },
      {
        id: 3,
        kind: 'input',
        name: 'email',
        type: 'email',
        format: 'email',
        placeholder: 'Почта',
        validationRule: /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i,
        required: true,
      },
    ],
  },
  {
    id: 4,
    title: 'Ура, всё получилось!',
    fields:[],
  },
];

export default {
  components: {
    StepForm
  },
  STEPS
};
</script>

<template>
<section class="section section_gray py-[20px] md:py-[40px] lg:py-[80px]">
  <div class="container container--min">
    <step-form
     title="Рассчитать стоимость автомобиля"
     apiUrl="/form/send/"
     action="comission"
     :steps="$options.STEPS" />
  </div>
</section>
</template>